import React, { useRef, useEffect, CSSProperties } from "react";
import styles from "./Checkbox.module.scss";
import { clx } from "../utils/stringUtils";

type CheckboxProps = {
	indeterminate?: boolean;
	isChecked?: boolean;
	isDisabled?: boolean;
	controlSize?: "sm" | "m" | "l";
	onChange?: (isChecked: boolean, event: React.MouseEvent<HTMLInputElement>) => void;
	inputStyle?: CSSProperties;
	className?: string;
	id?: string;
};

const Checkbox: React.FC<CheckboxProps> = ({
	indeterminate = false,
	isChecked = false,
	controlSize = "m",
	onChange,
	isDisabled = false,
	inputStyle = {},
	className,
	id,
}) => {
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.indeterminate = indeterminate;
		}
	}, [indeterminate]);

	return (
		<input
			id={id}
			disabled={isDisabled}
			className={clx(styles.main, styles[controlSize], className)}
			style={inputStyle}
			type="checkbox"
			checked={isChecked}
			ref={inputRef}
			onClick={(e) => {
				e.stopPropagation();
				onChange?.(!isChecked, e);
			}}
			onChange={() => void 0}
		/>
	);
};

export default Checkbox;
